/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';

import {
  Typography,
} from '@material-ui/core';
import BacePolicyEn from '../components/base_policy_en';

const IndexPage = () => (
  <BacePolicyEn>
    <ul>
      <li><Typography paragraph variant="body2">Account ID</Typography></li>
      <li><Typography paragraph variant="body2">User generated data</Typography></li>
      <li><Typography paragraph variant="body2">Files, Images, Videos, etc</Typography></li>
    </ul>
  </BacePolicyEn>
);

export default IndexPage;
